import 'src/components/common/Spinner.css';

function Spinner() {
  return (
    <div className="loader-wrapper">
      <div className="loader"></div>
    </div>
  );
}

export default Spinner;
